var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "8.604in",
    height: "8.551in",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd",
    viewBox: "0 0 860 855",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier"
  }), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M860 428c-1,-82 -25,-162 -70,-231 -45,-69 -109,-123 -183,-157 -75,-34 -158,-45 -239,-33 -81,12 -157,47 -219,100 -62,54 -107,124 -131,202 -23,79 -24,162 -1,241 23,79 67,150 128,204 61,54 137,90 218,103l0 -305 -108 0 0 -125 108 0 0 -95c-2,-22 0,-45 7,-66 7,-21 19,-40 34,-56 15,-16 34,-29 55,-37 21,-8 43,-11 65,-10 32,0 64,3 96,9l0 108 -54 0c-9,-1 -19,0 -28,3 -9,3 -17,8 -24,14 -7,7 -12,14 -15,23 -3,9 -4,18 -4,27l0 81 119 0 -19 125 -99 0 0 301c102,-16 194,-68 261,-146 67,-78 103,-178 102,-281z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.842769dd24ff88af6397315ee993c7ad.svg";
export { ForwardRef as ReactComponent };